import React from "react";
import { useParams } from "@tanstack/react-router";
import { useWorkspace } from "#app/lib/data/workspace-context";

/** Validates the $workspace URL param matches the active workspace. Switches if not. */
export function useWorkspaceRouteValidation() {
  const { workspace } = useParams({ strict: false }) as { workspace?: string };
  const { activeWorkspace, workspaces, switchWorkspace, isLoading } =
    useWorkspace();

  React.useEffect(() => {
    if (!workspace || isLoading) return;
    if (activeWorkspace?.urlPath === workspace) return;
    const target = workspaces.find((w) => w.urlPath === workspace);
    if (target) switchWorkspace(target.workspaceId);
  }, [workspace, activeWorkspace?.urlPath, workspaces, isLoading, switchWorkspace]);
}
